import Vue from 'vue'

import Axios from 'axios'
import PortalVue from 'portal-vue'
import VueNumerals from 'vue-numerals'
import numeral from 'numeral'

import {VTooltip} from 'v-tooltip'
import VueI18n from 'vue-i18n'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

import App from './App.vue'
import router from './router'
import httpMixin from './mixins/http-mixin'
import analyticsMixin from '@product-common/mixins/analytics.js'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import formHelpersMixin from './mixins/form-helpers-mixin.js'
import gaMixin from './mixins/ga-mixin.js'
import ScriptLoaderPlugin from './plugins/script-loader-plugin.js'
import messages_en from '@common/i18n/messages_en'
import moment from 'moment'
import VueAnalytics from 'vue-analytics';

import 'vue-date-pick/dist/vueDatePick.css'
import 'ant-design-vue/dist/antd.less'
import '@common/assets/tailwind.css'
import '@product-common/assets/style.css'
import * as VueGoogleMaps from 'vue2-google-maps'

import {
    Affix, Alert,
    Button,
    Checkbox,
    Collapse,
    DatePicker,
    Icon,
    Input,
    InputNumber,
    message,
    Pagination,
    Popconfirm,
    Radio,
    Select,
    Table,
    Transfer
} from 'ant-design-vue'

const data = {
    loadingProgress: 0,
    investorProfile: null
};

Vue.config.productionTip = false;

Vue.prototype.$isProd = process.env.VUE_APP_ENV === 'production';

Vue.prototype.$http = Axios;
Vue.prototype.$http.interceptors.response.use(undefined, err => new Promise((() => {
    if (err.response.status === 403) {
        localStorage.removeItem('web_token');
        router.push('/');
    }
    throw err;
})));

Vue.directive('tooltip', VTooltip);

message.config({
    top: '120px',
    duration: 2,
    maxCount: 3,
});
Vue.prototype.$message = message;

Vue.use(VueGoogleMaps, {load: {key: ''}});
Vue.use(PortalVue);
Vue.use(VueNumerals);
Vue.use(Pagination);
Vue.use(Table);
Vue.use(Icon);
Vue.use(InputNumber);
Vue.use(Transfer);
Vue.use(Popconfirm);
Vue.use(Button);
Vue.use(DatePicker);
Vue.use(Select);
Vue.use(Input);
Vue.use(Checkbox);
Vue.use(Collapse);
Vue.use(Radio);
Vue.use(Alert);
Vue.use(Affix);

Vue.use(ScriptLoaderPlugin);
Vue.use(VueI18n);

Vue.use(VueAnalytics, {
    id: 'UA-186557315-1',
    debug: {
        enabled: !Vue.prototype.$isProd,
        sendHitTask: Vue.prototype.$isProd
    },
    disableScriptLoader: Vue.prototype.$isProd // on prod ga is loaded through segment.io/GTM
});

Vue.component('VueSlider', VueSlider);
Vue.component(VueQrcode.name, VueQrcode);

//global components
Vue.component('k-button', () => import('@common/components/KButton'));
Vue.component('k-page', () => import('@common/components/layouts/KPage'));
Vue.component('k-container', () => import('@common/components/layouts/KContainer'));
Vue.component('k-section', () => import('@common/components/layouts/KSection'));

Vue.component('k-input', () => import('./components/KInput'));
Vue.component('k-checkbox', () => import('./components/KCheckbox'));
Vue.component('k-select', () => import('./components/KSelect'));
Vue.component('k-footer', () => import('./components/KFooter'));
Vue.component('k-alert', () => import('./components/KAlert'));
Vue.component('k-country-flags', () => import('./components/KCountryFlags'));
Vue.component('k-panel', () => import('./components/KPanel'));
Vue.component('k-panel-row', () => import('./components/KPanelRow'));
Vue.component('k-panel-property', () => import('./components/KPanelProperty'));
Vue.component('k-panel-header', () => import('./components/KPanelHeader'));
Vue.component('k-panel-sub-header', () => import('./components/KPanelSubHeader'));
Vue.component('k-spacer', () => import('./components/KSpacer'));
Vue.component('k-table', () => import('./components/KTable'));
Vue.component('k-back', () => import('./components/KBack'));
Vue.component('k-slider', () => import('./components/KSlider'));

//mixins
Vue.mixin(analyticsMixin);
Vue.mixin(httpMixin);
Vue.mixin(formHelpersMixin);
Vue.mixin(gaMixin);

//filters
Vue.filter('currencyFormat', (val, currencySymbol = '$', format = '0,0[.]00') => {
    return currencySymbol + numeral(val).format(format);
});
Vue.filter('currencyFormatWithoutDecimals', (val, currencySymbol = '$', format = '0,0') => {
    return currencySymbol + numeral(val).format(format);
});
Vue.filter('dateFormat', (val, format = 'DD MMMM YYYY') => {
    return val ? moment(val).format(format) : '';
});
Vue.filter('dateFormatShort', (val, format = 'DD MMM YYYY') => {
    return val ? moment(val).format(format) : '';
});
Vue.filter('documentName', (val) => {
    let firstPart = capitalizeFirstLetter(val.split('.')[0]);
    return firstPart.split('-')
        .join(' ');

});
Vue.filter('enumValue', (val) => {
    let split = val.toLowerCase().split('_')
    return [capitalizeFirstLetter(split[0])].concat(split.splice(1))
        .join(' ');
});

function capitalizeFirstLetter(string) {
    return string.charAt(0)
        .toUpperCase() + string.slice(1);
}

const messages = {
    en: messages_en
}

const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: "en",
    messages
});

new Vue({
    data,
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');
